import  { useState,useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CoupanServices from '../../services/CoupanServices';
import ProviderServices from '../../services/ProviderServices';

function AddCoupon() {
    const navigate = useNavigate();
    const providers = [
        {
            id: 1,
            name: "Amazon"
        },
        {
            id: 2,
            name: "Flipkart"
        },
        {
            id: 3,
            name: "Myntra"
        },
        {
            id: 4,
            name: "AJIO"
        }
    ];


    // ==========================================
    // FORM STATE
    // ==========================================

    const [formValues, setFormValues] = useState({

        providerId: "",

        name: "",

        couponCode: "",

        description: "",

        affiliateLink: "",

        status: "Active"

    });


    // ==========================================
    // HANDLE INPUT CHANGE
    // ==========================================

    const handleInputChange = (event) => {

        const { name, value } = event.target;

        setFormValues((prev) => ({
            ...prev,
            [name]: value
        }));

    };


    // ==========================================
    // VALIDATION
    // ==========================================

    const validateForm = () => {

        // Provider
        if (!formValues.providerId) {

            alert("Please select provider.");

            return false;
        }


        // Coupon Name
        if (!formValues.name.trim()) {

            alert("Please enter coupon name.");

            return false;
        }


        // Description
        if (!formValues.description.trim()) {

            alert("Please enter coupon description.");

            return false;
        }


        // Affiliate Link
        if (!formValues.affiliateLink.trim()) {

            alert("Please enter affiliate link.");

            return false;
        }


        // URL validation
        try {

            new URL(formValues.affiliateLink);

        } catch (error) {

            alert("Please enter a valid affiliate link.");

            return false;
        }


        return true;
    };


    // ==========================================
    // SUBMIT
    // ==========================================

    const handleSubmit = async (event) => {

        event.preventDefault();

        if (!validateForm()) return;


        try {

            // ==========================================
            // SELECTED PROVIDER
            // ==========================================

            const selectedProvider = providers.find(
                (provider) =>
                    String(provider.id) ===
                    String(formValues.providerId)
            );


            // ==========================================
            // COUPON DATA
            // ==========================================

            const couponData = {

                id: Date.now(),

                providerId:
                    Number(formValues.providerId),

                providerName:
                    selectedProvider?.name || "",

                name:
                    formValues.name.trim(),

                couponCode:
                    formValues.couponCode.trim(),

                description:
                    formValues.description.trim(),

                affiliateLink:
                    formValues.affiliateLink.trim(),

                status:
                    formValues.status

            };


            // Check data
            console.log(
                "Coupon Data:",
                couponData
            );


            // ==========================================
            // API
            // ==========================================

            await CoupanServices.createCoupan(
                couponData
            );


            alert(
                "Coupon created successfully"
            );


            navigate("/coupon");


        } catch (error) {

            console.error(
                "Failed to create Coupon",
                error
            );

            alert(
                error.response?.data?.message ||
                "Failed to create Coupon"
            );

        }

    };


    return (
        <>
            <div className="right_col" role="main">

                {/* =====================================
                    HEADER
                ===================================== */}

                <div className="title-box">

                    <h2>
                        Generate Coupon 
                    </h2>

                    <div className="container-box-top-header-right">

                        <Link
                            className="list-banner-btn"
                            to="/coupon"
                        >
                            Coupan Code List
                        </Link>

                    </div>

                </div>


                {/* =====================================
                    FORM
                ===================================== */}

                <div className="container-box px-5">

                    <div className="container-box-inner table-reponsive-tabe">

                        <div className="page-details">

                            <form onSubmit={handleSubmit}>

                                <div className="row">


                                    {/* =================================
                                        PROVIDER
                                    ================================= */}

                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Provider
                                                <span className="red">
                                                    *
                                                </span>
                                            </label>

                                            <select
                                                name="providerId"
                                                className="form-control"
                                                value={
                                                    formValues.providerId
                                                }
                                                onChange={
                                                    handleInputChange
                                                }
                                            >

                                                <option value="">
                                                    Select Provider
                                                </option>

                                                {providers.map(
                                                    (provider) => (

                                                        <option
                                                            key={
                                                                provider.id
                                                            }
                                                            value={
                                                                provider.id
                                                            }
                                                        >
                                                            {
                                                                provider.name
                                                            }
                                                        </option>

                                                    )
                                                )}

                                            </select>

                                        </div>

                                    </div>


                                    {/* =================================
                                        COUPON NAME
                                    ================================= */}

                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Name Of Coupon
                                                <span className="red">
                                                    *
                                                </span>
                                            </label>

                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                value={
                                                    formValues.name
                                                }
                                                onChange={
                                                    handleInputChange
                                                }
                                                placeholder="Enter coupon name"
                                            />

                                        </div>

                                    </div>


                                    {/* =================================
                                        COUPON CODE
                                    ================================= */}

                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Coupon Code
                                            </label>

                                            <input
                                                type="text"
                                                name="couponCode"
                                                className="form-control"
                                                value={
                                                    formValues.couponCode
                                                }
                                                onChange={
                                                    handleInputChange
                                                }
                                                placeholder="e.g. SAVE20"
                                            />

                                        </div>

                                    </div>


                                    {/* =================================
                                        STATUS
                                    ================================= */}

                                    <div className="col-lg-6 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Status
                                                <span className="red">
                                                    *
                                                </span>
                                            </label>

                                            <select
                                                name="status"
                                                className="form-control"
                                                value={
                                                    formValues.status
                                                }
                                                onChange={
                                                    handleInputChange
                                                }
                                            >

                                                <option value="Active">
                                                    Active
                                                </option>

                                                <option value="Inactive">
                                                    Inactive
                                                </option>

                                            </select>

                                        </div>

                                    </div>


                                    {/* =================================
                                        AFFILIATE LINK
                                    ================================= */}

                                    <div className="col-lg-12 col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Affiliate Link
                                                <span className="red">
                                                    *
                                                </span>
                                            </label>

                                            <input
                                                type="url"
                                                name="affiliateLink"
                                                className="form-control"
                                                value={
                                                    formValues.affiliateLink
                                                }
                                                onChange={
                                                    handleInputChange
                                                }
                                                placeholder="https://example.com/affiliate-link"
                                            />

                                        </div>

                                    </div>


                                    {/* =================================
                                        DESCRIPTION
                                    ================================= */}

                                    <div className="col-sm-12">

                                        <div className="input-field">

                                            <label>
                                                Description
                                                <span className="red">
                                                    *
                                                </span>
                                            </label>

                                            <textarea
                                                className="form-control video-desc"
                                                name="description"
                                                value={
                                                    formValues.description
                                                }
                                                onChange={
                                                    handleInputChange
                                                }
                                                placeholder="Enter coupon description"
                                            />

                                        </div>

                                    </div>

                                </div>


                                {/* =================================
                                    SUBMIT
                                ================================= */}

                                <button
                                    className="submit-green-btn"
                                    type="submit"
                                >
                                    SUBMIT
                                </button>

                            </form>

                        </div>

                    </div>

                </div>

            </div>
        </>
    );
}

export default AddCoupon;